import { ProjectModel } from '../../model/project.model';

export class UniformDirectPrintingModel {

  public get useUniformDirectPrintingFontSize(): boolean {
    return this.projectModel.currentInfoProperties.getBoolean('useUniformDirectPrintingFontSize');
  }

  public set useUniformDirectPrintingFontSize(value: boolean) {
    this.projectModel.currentInfoProperties.setBoolean('useUniformDirectPrintingFontSize', value);
  }

  public uniformFontSize: number | undefined = undefined;

  constructor(
    private readonly projectModel: ProjectModel,
  ) {
  }
}
